import React from 'react';

import { Paper, Typography } from '@mui/material';

import classes from './PaperWithTitle.module.scss';

type PaperWithTitleProps = {
  title?: string;
  customTitle?: React.ReactNode;
  content: React.ReactNode;
  hasTopMargin?: boolean;
};

const PaperWithTitle = ({
  title,
  customTitle,
  content,
  hasTopMargin,
}: PaperWithTitleProps) => {
  const sx = hasTopMargin ? { mt: 2 } : null;

  return (
    <Paper variant="box" className={classes.container} sx={sx}>
      <div className={classes.titleContainer}>
        {customTitle ?? <Typography className={classes.title}>{title}</Typography>}
      </div>
      <div className={classes.line} />
      <div className={classes.bodyContainer}>{content}</div>
    </Paper>
  );
};

export { PaperWithTitle };
